import { render, staticRenderFns } from "./StorageAutoScale.vue?vue&type=template&id=c7e987c2&scoped=true&"
import script from "./StorageAutoScale.vue?vue&type=script&lang=js&"
export * from "./StorageAutoScale.vue?vue&type=script&lang=js&"
import style0 from "./StorageAutoScale.vue?vue&type=style&index=0&id=c7e987c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e987c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7e987c2')) {
      api.createRecord('c7e987c2', component.options)
    } else {
      api.reload('c7e987c2', component.options)
    }
    module.hot.accept("./StorageAutoScale.vue?vue&type=template&id=c7e987c2&scoped=true&", function () {
      api.rerender('c7e987c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autonomous/StorageAutoScale.vue"
export default component.exports